import { IFormViewForm } from 'components/FormView';

const ProductPriceScheduleComments: IFormViewForm = {
  id: 'ProductPriceScheduleComments',
  layout: {
    rows: 1,
    columns: 1
  },
  fields: [
    {
      id: '1',
      type: 'PAPER_CONTAINER',
      props: {
        name: 'Comments',
        fullWidth: true
      },
      position: {
        row: 1,
        col: 1,
        colspan: 3
      },
      children: [
        {
          id: '1',
          type: 'TEXT_AREA',
          props: {
            label: 'Comments',
            name: 'comment',
            fullWidth: true,
            style: {
              height: '650px'
            }
          }
        }
      ]
    }
  ]
};
export default ProductPriceScheduleComments;
